import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import RenginiaiService from "../Api/RenginiaiService";
import ContentBlock from "../Components/ContentBlock";
import Footer from "../Components/Footer";
import TopNavBar from "../Components/TopNavBar";
import { useParams } from 'react-router-dom';


function withRouter(Component) {
    function ComponentWithRouter(props) {
        let params = useParams()
        return <Component {...props} params={params} />
    }
    return ComponentWithRouter
}

class RenginysPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            name: '',
            Image: '',
            Description: '',
            IsForKids: false,
        }
    };

    componentDidMount() {
        console.log(this.props.params.name);
        RenginiaiService.getRenginys(this.props.params.name).then((response) => {
            this.setState({
                name: response.data.Name,
                Image: response.data.Files[0].Path,
                Description: response.data.Description,
                IsForKids: response.data.IsForKids,
            });
        });
    }
    
    render() {

        const pageStyle = {
            backgroundImage: "url(/renginiai-page-background.jpg)",
            height: '100vh',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
        };

        return (
            <Container fluid style={pageStyle}>
                <TopNavBar activeRoute={1} />
                <h1 className='page-title'>{this.state.name}</h1>
                <Container>
                    <ContentBlock>
                        <Row>
                            <Col xs={12} md={6} lg={6}>
                                <img src={this.state.Image} alt={this.state.name} style={{ marginTop: '10%', width: '100%' }} />
                            </Col>
                            <Col xs={12} md={6} lg={6}>
                                <div className='course-description-block'>
                                    <h2 className='course-description-title center-text'>{this.state.name}</h2>
                                    <div>{this.state.Description}</div>
                                </div>
                                <div>
                                    <h2 className='course-description-title center-text' style={{ marginTop: '10%' }}>Užklausos forma</h2>
                                    <Form>
                                        <Form.Group controlId="firstName">
                                            <Form.Label>Vardas</Form.Label>
                                            <Form.Control type="text" placeholder="Vardas" />
                                        </Form.Group>
                                        <Form.Group controlId="phone">
                                            <Form.Label>Telefonas</Form.Label>
                                            <Form.Control type="text" placeholder="Telefonas" />
                                        </Form.Group>
                                        <Form.Group controlId="email">
                                            <Form.Label>El.paštas</Form.Label>
                                            <Form.Control type="email" placeholder="El.paštas" />
                                        </Form.Group>
                                        <Form.Group controlId="message">
                                            <Form.Label>Žinutė</Form.Label>
                                            <Form.Control as="textarea" rows={3} placeholder="Žinutė" />
                                        </Form.Group>
                                        <Form.Group controlId="submit">
                                            <div style={{marginTop:'10px'}}>
                                                <Button type="submit" variant="outline-light">Siųsti</Button>
                                            </div>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </Col>
                        </Row>
                    </ContentBlock>
                </Container>
                <Footer></Footer>
            </Container>
        )
    }
}

export default withRouter(RenginysPage);
